
import React from 'react';
import {connect} from 'react-redux';
import { Formik, Field } from 'formik';
import * as yup from 'yup';
import { Form, Row, Col, Collapse, Card} from 'react-bootstrap';
import Stats from '../Stats';
import Pension from './Scenario/Pension';
import ApplicationHelpers from '../../ApplicationHelpers';


// const initialValues = {
//     client:{},
//     spouse:{}
// };
class Step4 extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
  handleSubmit(values,props) {
    // console.log('---here are values',values);
    let finalValues = {
        pensionBenefits: [{
            owner:'client',
            grossMonthlyBenefit: values.client.amount,
            startAge: values.client.age,
            // cola: values.client.cola,
            forLife:true,
            endAge:0
        }]
    };
    if(this.props.client.isMarried === 'true'){
        finalValues.pensionBenefits.push({
            owner:'spouse',
            grossMonthlyBenefit: values.spouse.amount,
            startAge: values.spouse.age,
            // cola: values.spouse.cola,
            forLife:true,
            endAge:0
        });
    }
    this.props.upliftState(finalValues,'scenario');
    this.props.nextStep();
    return;
  }
   
  render() {
    let form = this.props.form;
    let ages = {client:60,spouse:60};
    ages.client =  ApplicationHelpers.ageAt(form.client.birthdate,new Date(),true);
    if(form.client && form.client.isMarried === 'true'){
        ages.spouse =  ApplicationHelpers.ageAt(form.client.spouse.birthdate,new Date(),true);
    }
      let baseSchema = {
        client: yup.object().shape({
                age: yup.number().positive().integer('Age must be an integer').min(ages.client,'Age should be equal or greater than current age').max(100,'Age should not be more than 100'),
                amount: yup.number(),
                // cola: yup.number()
        })
      };
     if(this.props && this.props.client && this.props.client.isMarried === 'true'){
         baseSchema.spouse = yup.object().shape({
                age: yup.number().positive().integer('Age must be an integer').min(ages.spouse,'Age should be equal or greater than current age').max(100,'Age should not be more than 100'),
                amount: yup.number(),
                // cola: yup.number()
        })
     }
     const schema = yup.object().shape(baseSchema);
    return(

                 <Formik
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={this.props}
                    validationSchema={schema}
                    onSubmit={this.handleSubmit}
                >
                {({
                        handleSubmit,
                        handleChange,
                        handleBlur,
                        setFieldValue,
                        setFieldTouched,
                        values,
                        errors,
                        touched,
                        isSubmitting
                    }) => (
                        <Form onSubmit={handleSubmit} >
                            <Card className="stepChild">
                            <Card.Header>
                                <Row >
                                <span style={{'position':'absolute','paddingLeft':'15px'}}><strong>4.</strong></span>
                                    <Col md={"10"} sm={"12"} style={{'paddingLeft':'35px'}}>
                                        {this.props.getStepHeader(4) } 
                                    </Col>
                                    <Col md={"2"} sm={"12"}>
                                        <Stats type="edit" step={4} {...this.props} />
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Collapse in={this.props.isActive}>
                            <Card.Body>
                                <Card>
                                    <Card.Header>{this.props.client.firstName}'s Information</Card.Header>
                                    <Card.Body>
                                        <Field
                                            component={Pension} 
                                            handleSubmit={handleSubmit} 
                                            handleChange={handleChange} 
                                            handleBlur={handleBlur}
                                            setFieldValue={setFieldValue}
                                            setFieldTouched={setFieldTouched}
                                            values={values}
                                            errors={errors }
                                            touched={touched}
                                            isSubmitting={isSubmitting} 
                                            form={this.props.form}
                                            type="client" />
                                    </Card.Body>
                                </Card>
                                {this.props.client.isMarried === 'true' &&
                                <div>
                                    <br />                         
                                <Card>
                                    <Card.Header>{this.props.client.spouse.firstName}'s Information</Card.Header>
                                    <Card.Body>
                                        {this.props.client.isMarried === 'true' &&
                                            <Field
                                            component={Pension} 
                                            handleSubmit={handleSubmit} 
                                            handleChange={handleChange} 
                                            handleBlur={handleBlur}
                                            setFieldValue={setFieldValue}
                                            setFieldTouched={setFieldTouched}
                                            values={values}
                                            errors={errors }
                                            touched={touched}
                                            isSubmitting={isSubmitting} 
                                            form={this.props.form}
                                            type="spouse" />
                                        }
                                    </Card.Body>
                                </Card>
                                </div>
                                }
                                <Form.Row>
                            <Form.Group as={Col} md="12" style={{"padding":"0px","margin":"0px"}} controlId="step4Continue">
                                <Col md={"12"} sm={"12"}>
                                    <br />
                                    <Stats type='continue' step={4} {...this.props} />
                                </Col>
                            </Form.Group>
                        </Form.Row>
                        </Card.Body>
                        </Collapse>
                        </Card>
                        
                        </Form>
                    )}
                    </Formik>
    );
   }
}
const mapStateToProps = (state , ownProps) => {
    let {form} = state.mainState;
    let {client,scenario} = form;
        if(!client.isMarried || client.isMarried === 'false'){
            client.spouse = {};
            scenario.spouse = {employment:{}};
        }
        let css={},sss={};
        if(Array.isArray(scenario.pensionBenefits)){
            let pensionBenefits = scenario.pensionBenefits;
            pensionBenefits.map(ss =>{
                if(ss.owner === 'client'){
                    css=ss;
                }
                else if(ss.owner === 'spouse'){
                    sss = ss;
                }
                return true;
            });
        }
        return {
            form,
            isMarried:client.isMarried,
            client:{
                ...client,
                isMarried:client.isMarried,
                age: css.startAge,
                amount: css.grossMonthlyBenefit
            },
            spouse: {
                ...client.spouse,
                firstName: client.spouse.firstName,
                age: sss.startAge,
                amount: sss.grossMonthlyBenefit
            },
            scenario,
            ...ownProps
        }
  }
 export default connect(
    mapStateToProps,
    null
  )(Step4)